import { useEffect, useState } from "react";
import { Vote, Check } from "lucide-react";
import { api } from "../lib/api";
import { getSessionId } from "../lib/utm";
import { track } from "../lib/analytics";
import { Reveal } from "./Reveal";
import ShareMenu from "./ShareMenu";

// Lightweight fan vote with honeypot + one vote per session/IP. Renders nothing when no poll is active.
export default function FanPoll() {
  const [poll, setPoll] = useState(null);
  const [busy, setBusy] = useState(false);
  const [hp, setHp] = useState("");

  useEffect(() => {
    api.get(`/polls/active?sessionId=${getSessionId()}`).then((r) => setPoll(r.data)).catch(() => {});
  }, []);

  if (!poll) return null;
  const voted = poll.voted !== null && poll.voted !== undefined;

  const vote = async (i) => {
    if (voted || busy) return;
    setBusy(true);
    try {
      const r = await api.post(`/polls/${poll.internalId}/vote`, { optionIndex: i, sessionId: getSessionId(), website: hp });
      setPoll(r.data);
      track("fan_vote", { metadata: { pollId: poll.internalId, option: poll.options[i]?.label } });
    } catch {}
    setBusy(false);
  };

  return (
    <section data-testid="fan-poll" className="px-6 py-16 sm:px-10 lg:px-16">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-surface/60 p-7 sm:p-10">
            <div className="absolute -left-20 -top-20 h-56 w-56 rounded-full bg-gold/10 blur-3xl" />
            <div className="relative">
              <p className="mb-2 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.3em] text-gold"><Vote size={14} /> Fan Vote</p>
              <h2 data-testid="poll-question" className="font-display text-2xl font-bold uppercase leading-tight tracking-tight text-white sm:text-4xl">{poll.question}</h2>
              <input type="text" value={hp} onChange={(e) => setHp(e.target.value)} className="hidden" tabIndex={-1} autoComplete="off" aria-hidden="true" />
              <div className="mt-6 space-y-2.5">
                {poll.options.map((o, i) => (
                  <button
                    key={i}
                    data-testid={`poll-option-${i}`}
                    onClick={() => vote(i)}
                    disabled={voted || busy}
                    className={`relative flex w-full items-center justify-between overflow-hidden rounded-2xl border px-5 py-3.5 text-left text-sm font-semibold transition-colors ${voted ? "border-white/10" : "border-white/15 hover:border-gold/50"} ${poll.voted === i ? "text-gold" : "text-white"}`}
                  >
                    {voted && <span className="absolute inset-y-0 left-0 bg-gold/15 transition-all duration-700" style={{ width: `${o.pct}%` }} />}
                    <span className="relative flex items-center gap-2">{poll.voted === i && <Check size={14} />}{o.label}</span>
                    {voted && <span className="relative text-xs text-white/60">{o.pct}%</span>}
                  </button>
                ))}
              </div>
              <div className="mt-5 flex flex-wrap items-center gap-3 text-xs text-white/40">
                <span data-testid="poll-total">{poll.total} vote{poll.total === 1 ? "" : "s"}</span>
                {voted && <ShareMenu kind="home" slug="vote" title="DJ Código fan vote" text={`I just voted: ${poll.options[poll.voted]?.label} — ${poll.question}`} eventType="share_song" label="Share your pick" />}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
